import useSWR from "swr";


export const useSaveGoogleReviews = (restaurantId?: string) => {
  const fetcherKey = restaurantId ? `/external_api/restaurants/${restaurantId}/google/reviews/save/` : null;
  const { data: reviews, error, isLoading } = useSWR(fetcherKey);
  return { isLoading, error };
};